import React from "react";
import { Popover } from "@mantine/core";
import { InformationCircleIcon } from "@heroicons/react/outline";
import { ReserveFormUsers } from "@/components/reserve/Reserve/controls/ReserveFormUsers";
import { ReserveFormOrganizer } from "@/components/reserve/Reserve/controls/ReserveFormOrganizer";
import { useReserveForm } from "@/components/reserve/Reserve/ReserveFormProvider";

export const ReserveFormAdminReservation: React.FC = () => {
  const { enableAdminReservation, isMeetingRoom } = useReserveForm();
  if (!enableAdminReservation) return null;

  return (
    <div className="mt-2 text-gray-500">
      {!isMeetingRoom ? (
        <>
          <div className="flex items-center">
            <span className={styles.Label}>
              User
            </span>
            <Popover width={250} position="top" shadow="md">
              <Popover.Target>
                <InformationCircleIcon className="ml-2 h-5 w-5 cursor-pointer text-gray-400" />
              </Popover.Target>
              <Popover.Dropdown className="z-20">
                <span>
                  As an admin or scheduler, you can make reservation on behalf
                  of other users.
                </span>
              </Popover.Dropdown>
            </Popover>
          </div>
          <ReserveFormUsers />
        </>
      ) : (
        <>
          <div className="flex items-center">
            <span className={styles.Label}>
              Organizer
            </span>
            <Popover width={300} position="top" shadow="md">
              <Popover.Target>
                <InformationCircleIcon className="ml-2 h-5 w-5 cursor-pointer text-gray-400" />
              </Popover.Target>
              <Popover.Dropdown className="z-20">
                <span>
                  Select an organizer for the meeting. As you are creating this
                  reservation on behalf of another user, you will not be the
                  organizer, nor one of the invitees.
                </span>
              </Popover.Dropdown>
            </Popover>
          </div>
          <ReserveFormOrganizer />
        </>
      )}
      <div className="relative pb-4">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-gray-300 border-t" />
        </div>
      </div>
    </div>
  );
};

const styles = {
  Label: "text-secondary [.tactic-v2_&]:text-secondary-foreground font-inter font-normal text-sm leading-none tracking-normal",
};